// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__184yr","inner":"Footer_inner__38bDB"};